export const SUPPORT_EMAIL = 'help@chatscontrol.com';
